// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container[data-v-1c4fcf64] {\n  flex-direction: column;\n  margin: 20px 30px;\n}\n.container .detailFlybox .order-list[data-v-1c4fcf64] {\n    display: flex;\n    flex-wrap: wrap;\n}\n.container .detailFlybox .order-item[data-v-1c4fcf64] {\n    width: 50%;\n    line-height: 30px;\n}\n", ""]);
// Exports
module.exports = exports;
